import React from 'react';
import {useDispatch} from 'react-redux';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import useForm, {FormDataType} from '../../../hooks/useForm';
import {AppDispatch} from '../../../redux/store';
import {loginWithEmail} from '../../../redux/slices/authSlice';
import ButtonStyle from '../../../styles/buttonStyle/buttonStyle';

const LogIn = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {formData, handleInputChange, handleSubmit} = useForm(
    {
      username: '',
      password: '',
    },
    ({username, password}: FormDataType) =>
      void dispatch(loginWithEmail({username, password})),
  );

  const {username, password} = formData;

  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        spacing={2}
        height="80vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column">
        <Grid item>
          <h1> Partner </h1>
        </Grid>
        <Grid item>
          <TextField
            type="text"
            name="username"
            value={username}
            onChange={handleInputChange}
            variant="outlined"
            placeholder="User name"
          />
        </Grid>
        <Grid item>
          <TextField
            type="password"
            name="password"
            value={password}
            onChange={handleInputChange}
            variant="outlined"
            placeholder="Password"
          />
        </Grid>
        <Grid item>
          <ButtonStyle>
            <Button type="submit" variant="contained" size="large">
              Log In
            </Button>
          </ButtonStyle>
        </Grid>
      </Grid>
    </form>
  );
};

export default LogIn;
